import axios from "axios";

const URL = {
  validate: `/validate-session`
};

const sessionValidationExclude = [
  "bad-request",
  "unauthorized",
  "not-found",
  "internal-server-error",
  "session-timeout",
  "session-timeout-admin",
  "session-timeout-cashiering"
];
const sessionCheckEvery = 60000;

const AuthService = {
  validateAuthentication: async () => {
    try {
      await axios.get(URL.validate);
      return true;
    } catch (error) {
      window.location = error.response.data.redirectTo;
    }
  }
};

const ValidateSession = async () => {
  const isExcludePage = path =>
    sessionValidationExclude.some(p => path.indexOf(p) !== -1);

  if (!isExcludePage(window.location.pathname)) {
    await AuthService.validateAuthentication();
    setTimeout(ValidateSession, sessionCheckEvery);
  }
};

export { ValidateSession };
